import ExcelJS from 'exceljs'

export const encodeToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    let result = ''
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onloadend = (e) => {
      result = e.target.result
      resolve(result)
    }
    reader.onerror = (e) => {
      reject(e)
    }
  })
}

const getCompleteFileType = (type) => {
  switch (type) {
    case 'pdf':
      return `application/${type}`
    case 'jpg':
    case 'jpeg':
    case 'png':
      return `image/${type}`
    case 'xls':
      return type
    default:
      return `application/${type}`
  }
}

export const isACorrectFormat = (filename, acceptedFormats) => {
  if (!filename || typeof filename !== 'string') {
    return false
  }
  let acceptedExtensions = acceptedFormats.map((item) => item.split('/')[1])
  let filenameAndExtension = filename.toLowerCase().split('.')
  // without filename or extension
  if (filenameAndExtension.length === 1) {
    return false
  }
  let extension = filenameAndExtension[filenameAndExtension.length - 1]
  return acceptedExtensions.indexOf(extension) > -1
}

export const covertStrToBlob = (str, fileExtension) => {
  const hexStr = str.slice(2)
  const buf = new ArrayBuffer(hexStr.length / 2)
  const byteBuf = new Uint8Array(buf)
  for (let i = 0; i < hexStr.length; i += 2) {
    byteBuf[i / 2] = parseInt(hexStr.slice(i, i + 2), 16)
  }
  const blob = new Blob([byteBuf], { type: getCompleteFileType(fileExtension) })
  return blob
}

export const downloadFile = (data, fileExtension, fileName) => {
  const base64Data = data.split("'")[1]
  const link = document.createElement('a')
  link.target = '_blank'
  link.href = `data:${getCompleteFileType(fileExtension)};base64,${base64Data}`
  link.download = `${fileName}.${fileExtension}`
  link.click()
}

export const getFormattedTime = () => {
  var today = new Date()
  var y = today.getFullYear()
  var m = today.getMonth() + 1 // JavaScript months are 0-based
  var d = today.getDate()
  var h = today.getHours()
  var mi = today.getMinutes()
  return d + '_' + m + '_' + y + '_' + h + '_' + mi
}

const getComboOption = (item, column, combos) => {
  const comboOption =
    column.comboId &&
    combos[column.comboId] &&
    combos[column.comboId].data.find(({ key }) => key === item[column.field])
  return comboOption
}

export const getFormatedValue = (item, column, combos, intl) => {
  switch (column.exportType) {
    case 'date': {
      return intl.formatDate(new Date(item[column.field]))
    }
    case 'combo': {
      const comboOption = getComboOption(item, column, combos)
      return comboOption ? comboOption.value : item[column.field]
    }
    case 'custom_combo': {
      const comboOption = getComboOption(item, column, combos)
      return comboOption ? comboOption.value : '' // if the column values with the combo not match. Show nothing.
    }
    default: {
      return item[column.field]
    }
  }
}

export const capitalizeStr = (str) => {
  if (!str || typeof str !== 'string') {
    return str || ''
  }
  return str
    .toLowerCase()
    .split(' ')
    .map((word) => {
      if (!word.length) {
        return ''
      }
      return word[0].toUpperCase() + word.substr(1)
    })
    .join(' ')
}

export const dataToXLS = async (data, columns, combos, intl, from, fileName) => {
  // Filtrar columnas exportables
  const exportableColumns = columns.filter(
    (column) => !column.hasOwnProperty('exportable') || column.exportable
  )

  // Crear workbook y worksheet
  const workbook = new ExcelJS.Workbook()
  const worksheet = workbook.addWorksheet('SheetJS')

  // Configurar columnas con headers
  worksheet.columns = exportableColumns.map((column) => ({
    header: intl.formatMessage({
      id: `pages.${from}.table.columns.${column.field}.title`,
    }),
    key: column.field,
    width: 15, // Puedes ajustar el ancho según necesites
  }))

  // Añadir filas de datos
  data.forEach((record) => {
    const rowData = {}
    exportableColumns.forEach((column) => {
      let value = ''
      if (record[column.field]) {
        value = getFormatedValue(record, column, combos, intl)
      } else {
        value = record[column.field]
      }
      rowData[column.field] = value
    })
    worksheet.addRow(rowData)
  })

  // Aplicar estilos a la fila de encabezados
  worksheet.getRow(1).font = { bold: true }
  worksheet.getRow(1).fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'FFE0E0E0' },
  }

  // Generar el archivo y descargarlo
  const buffer = await workbook.xlsx.writeBuffer()
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  link.click()
  window.URL.revokeObjectURL(url)
}
